import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// "Wir" — Firebase config (own project, separate from ClubConnect/SpotSwap).
// The apiKey below is a public client identifier, not a secret — it is safe
// to ship in the bundle. Access control is enforced via Firestore Security
// Rules (see firestore.rules in this repo), not by hiding this value.
const firebaseConfig = {
  apiKey: "AIzaSyDtIZLBPz2iAYT_IC2rHHqow1uOsaVhhR0",
  authDomain: "wir-app-huebbedigital.firebaseapp.com",
  projectId: "wir-app-huebbedigital",
  storageBucket: "wir-app-huebbedigital.firebasestorage.app",
  messagingSenderId: "439870226496",
  appId: "1:439870226496:web:2df481ed3f3cbb21221fa5",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// WebKit/Safari's fetch implementation doesn't support the streaming
// responses Firestore's default channel relies on, which surfaces as
// "Fetch API cannot load ... due to access control checks" in the console.
// Auto-detection still tries fetch-streaming first and only falls back
// after that failure, so the error still logs once; forcing long-polling
// (XHR-based, no streaming) skips the broken code path entirely.
//
// persistentLocalCache backs the client's cache with IndexedDB instead of
// memory: a write made while offline (dead spot, flight mode, connection
// drop) is durably queued on-device and still syncs once back online, even
// if the tab/app was closed and reopened in between. All app data itself
// still lives in Firestore under the signed-in couple, keyed by account —
// this only protects in-flight writes against being lost to a connectivity
// blip, it is not a substitute for being signed in.
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
// Same region every Cloud Function in functions/src/index.ts is deployed to.
export const functions = getFunctions(app, "europe-west1");
